import DOMPurify from 'dompurify';
import {defineNuxtPlugin} from '#imports';

export default defineNuxtPlugin(() => {
    const sanitize = DOMPurify.sanitize as (s: string) => string;

    return {
        provide: {
            sanitizeHtml: sanitize,
        },
    };
});
